var _rect, _path, _g, _g2, _g3, _path2, _path3, _rect2, _path4, _rect3, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
const SvgGamificationHeaderIcon = _ref => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.657,
    y: 24.344,
    width: 3.881,
    height: 1.164,
    rx: 0.582,
    stroke: "#E6E6E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6E6E6",
    d: "M14.129 23.845v2.164"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gamification-header-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.274 24.886h.222c.04 0 .073-.03.073-.065v-.262c0-.036-.033-.065-.074-.065h-.221c-.041 0-.074.03-.074.065v.262c0 .036.033.065.074.065Zm0 .458h.222c.04 0 .073-.03.073-.066v-.261c0-.036-.033-.066-.074-.066h-.221c-.041 0-.074.03-.074.066v.261c0 .036.033.066.074.066Zm.443 0h.222c.04 0 .074-.03.074-.066v-.261c0-.036-.033-.066-.074-.066h-.222c-.04 0-.074.03-.074.066v.261c0 .036.034.066.074.066Zm.444 0h.222c.04 0 .074-.03.074-.066v-.261c0-.036-.033-.066-.074-.066h-.222c-.04 0-.074.03-.074.066v.261c0 .036.034.066.074.066Zm-.444-.458h.222c.04 0 .074-.03.074-.065v-.262c0-.036-.033-.065-.074-.065h-.222c-.04 0-.074.03-.074.065v.262c0 .036.034.065.074.065Zm.37-.327v.262c0 .036.034.065.074.065h.222c.04 0 .074-.03.074-.065v-.262c0-.036-.033-.065-.074-.065h-.222c-.04 0-.074.03-.074.065Z",
    fill: "#2E2E2E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gamification-header-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.804 25.028h.153c.042 0 .076-.03.076-.065v-.131c0-.036-.034-.065-.076-.065h-.153c-.043 0-.077.029-.077.065v.13c0 .037.034.066.077.066Zm0 .327h.153c.042 0 .076-.03.076-.065v-.131c0-.036-.034-.066-.076-.066h-.153c-.043 0-.077.03-.077.066v.13c0 .037.034.066.077.066Zm0-.654h.153c.042 0 .076-.03.076-.065v-.13c0-.037-.034-.066-.076-.066h-.153c-.043 0-.077.03-.077.065v.13c0 .037.034.066.077.066Zm.383.327h.766c.042 0 .076-.03.076-.065v-.131c0-.036-.034-.065-.076-.065h-.766c-.042 0-.077.029-.077.065v.13c0 .037.035.066.077.066Zm0 .327h.766c.042 0 .076-.03.076-.065v-.131c0-.036-.034-.066-.076-.066h-.766c-.042 0-.077.03-.077.066v.13c0 .037.035.066.077.066Zm-.077-.85v.13c0 .037.035.066.077.066h.766c.042 0 .076-.03.076-.065v-.13c0-.037-.034-.066-.076-.066h-.766c-.042 0-.077.03-.077.065Z",
    fill: "#2D2D2D"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#gamification-header-icon_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.015 25.026h-.046l-.016-.014a.295.295 0 0 0 .091-.21c0-.177-.17-.322-.378-.322s-.377.145-.377.323c0 .178.169.322.377.322.094 0 .18-.03.246-.078l.016.014v.04l.29.247.087-.074-.29-.248Zm-.349 0c-.144 0-.261-.1-.261-.223 0-.124.117-.224.261-.224.145 0 .262.1.262.224 0 .123-.117.223-.262.223Z",
    fill: "#2E2E2E"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2E2E2E",
    d: "M17.191 9.638h.432v.37h-.432zM17.191 10.132h.432v.37h-.432zM17.191 10.625h.432v.37h-.432zM16.614 10.625h.432v.37h-.432zM16.614 10.132h.432v.37h-.432zM16.614 9.638h.432v.37h-.432zM16.038 9.638h.432v.37h-.432zM16.038 10.132h.432v.37h-.432zM16.038 10.625h.432v.37h-.432z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.981 10.996V9.638",
    stroke: "#8F9BB3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.629,
    y: 9.638,
    width: 1.585,
    height: 1.357,
    rx: 0.679,
    fill: "#2E2E2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.421 10.317c.135 0 .244-.094.244-.21 0-.116-.11-.21-.244-.21-.135 0-.244.094-.244.21 0 .116.11.21.244.21Zm0 .105c-.163 0-.487.07-.487.21v.104h.974v-.105c0-.14-.324-.21-.487-.21Z",
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.463,
    y: 9.638,
    width: 1.655,
    height: 1.357,
    rx: 0.679,
    fill: "#009D10"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.986 10.473a.067.067 0 0 1 .047-.01.07.07 0 0 1 .023.008.06.06 0 0 1 .018.014c.013.013.03.025.046.035.046.026.1.04.156.04a.31.31 0 0 0 .156-.04.245.245 0 0 0 .047-.034l.001-.002a.07.07 0 0 1 .086-.01c.013.008.022.02.024.034a.047.047 0 0 1-.012.04l-.002.001a.448.448 0 0 1-.3.115.448.448 0 0 1-.28-.096.245.245 0 0 1-.02-.019.049.049 0 0 1 .01-.075ZM9.03 10.141c0 .023-.01.046-.03.062a.112.112 0 0 1-.072.026.112.112 0 0 1-.072-.026.082.082 0 0 1-.03-.062c0-.023.01-.045.03-.062a.112.112 0 0 1 .072-.026c.027 0 .053.01.072.026.02.017.03.039.03.062Zm.593.088c.028 0 .054-.01.073-.026a.082.082 0 0 0 .03-.062.082.082 0 0 0-.03-.062.112.112 0 0 0-.073-.026.112.112 0 0 0-.072.026.082.082 0 0 0-.03.062c0 .023.011.046.03.062.02.016.045.026.072.026Z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "m6.313 30.946.035-27.64.008-2.42C6.358.093 7.013-.226 7.819.17l.934.463 8.384 4.146.607.3 5.206 2.575a472.08 472.08 0 0 1 1.378.681l.816.404.287.14 1.174.582c.21.102.415.205.614.304l.39.192 1.536.76c.023.012.048.024.071.038l.07.04.068.04a1.197 1.197 0 0 1 .075.05c.024.016.047.032.07.05.023.017.045.036.067.054.022.018.046.034.068.053a2.975 2.975 0 0 1 .137.124l.055.054a1.976 1.976 0 0 1 .12.13c.039.044.077.09.111.135l.006.007.006.007.01.013c.067.089.13.18.185.274.028.047.054.094.08.142l.01.02.028.058.022.047.014.031.011.026.022.052.03.079c.058.16.096.318.11.472v.003a1.5 1.5 0 0 1 .008.156c0 .016-.002 11.11-.005 12.159l-.005 1.628c-.002.403-.003 7.856-.005 8.295v.152l-.001.198v.007c-.002.18-.002.364-.002.546l-.001.29-.002.44-.001.583v.291l-.005 1.128v.03c-.006 1.791-.014 3.428-.02 4.399l-.001.068v.15l-.002.11-.001.103v.093l-.002.086v.134l-.002.054V43.888l-.001.025v.016a.495.495 0 0 1-.011.056l-.007.033-.008.033v.005c-.002.002-.002.005-.003.008l-.004.017c-.003.005-.004.012-.006.017a.715.715 0 0 1-.029.08l-.01.026c-.003.003-.005.008-.006.01 0 .002-.002.002-.002.005l-.003.004h-.001v.006l-.004.005v.001a.476.476 0 0 1-.063.103l-.001.003-.002.002-.021.026a.599.599 0 0 0-.025.03l-.033.032-.014.014-.022.02c-.012.01-.024.02-.037.028a.652.652 0 0 1-.226.11c-.29.086-.62.009-.912-.135l-6.698-3.313c-.941-.465-1.92-.95-2.908-1.437-.945-.469-1.898-.94-2.83-1.4l-3.138-1.553-5.716-2.825-.036-.02c-.384-.188-.723-.507-.964-.836-.301-.413-.491-.891-.49-1.32v-.818Z",
    fill: "url(#gamification-header-icon_svg__d)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.882 9.356a.195.195 0 0 0-.029-.151.276.276 0 0 0-.129-.103.197.197 0 0 0-.153.019l-.756.392a.177.177 0 0 0-.08.086.196.196 0 0 0-.01.121l.202.889a.225.225 0 0 0 .09.128c.047.035.098.05.154.043a.155.155 0 0 0 .128-.078.158.158 0 0 0 .027-.146l-.171-.742.64-.342a.145.145 0 0 0 .087-.116ZM18.359 11.185c.275 1.387-1.03 1.756-1.505.686a1.115 1.115 0 0 1-.045-.834c.098-.272.296-.49.65-.504.403.028.866.286.9.652ZM18.696 14.074c.21 1.45-.629.894-1.853.286-.888-.441-1.721-.706-1.237-1.284.429-.513.903-.581 1.368-.311.204.118.438.195.681.232.555.086.935.534 1.041 1.077ZM23.072 14.112a.207.207 0 0 0-.155-.043.155.155 0 0 0-.128.077.157.157 0 0 0-.027.146l.17.742-.639.342a.144.144 0 0 0-.086.116c-.012.05-.003.1.028.151a.273.273 0 0 0 .13.103.197.197 0 0 0 .152-.02l.756-.392a.177.177 0 0 0 .08-.086.194.194 0 0 0 .01-.121l-.202-.889a.218.218 0 0 0-.09-.126Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.088 15.576c-1.55.171-3.157-.73-3.732-2.16-.324-.808-.267-1.675.157-2.379.371-.617.993-1.062 1.75-1.253 1.677-.425 3.554.508 4.185 2.079.325.807.268 1.674-.157 2.378-.37.617-.993 1.063-1.75 1.254-.15.038-.3.065-.453.081Zm-1.325-5.58a2.98 2.98 0 0 0-.401.072c-.666.169-1.213.56-1.541 1.105-.381.633-.43 1.415-.137 2.146.571 1.422 2.257 2.27 3.76 1.89.665-.168 1.212-.56 1.54-1.104.381-.633.43-1.415.137-2.146-.521-1.297-1.969-2.116-3.358-1.963ZM9.397 16.02l4.394 2.197v-2.41l-4.394-2.198v2.41ZM9.397 18.764l4.394 2.198v-2.41l-4.394-2.198v2.41ZM9.397 21.51l4.394 2.198v-2.411l-4.394-2.198v2.41ZM9.397 24.255l4.394 2.197v-2.41l-4.394-2.198v2.411ZM9.397 27l4.394 2.198v-2.41l-4.394-2.199V27Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.71 14.996.957.48v-.158l-.957-.48v.159Z",
    fill: "#fff"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.294 15.223 1.228.616v-.158l-1.228-.616v.158ZM11.768 15.962l.645.323v-.158l-.645-.323v.158ZM10.693 15.813l1.396.7v-.158l-1.396-.7v.158ZM12.298 16.617l.416.209v-.158l-.416-.209v.158ZM10.294 16.033l.944.473v-.157l-.944-.473v.157Z",
    fill: "#FF0082"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.426 16.602.497.248v-.158l-.497-.248v.158Z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.136 16.957.614.308v-.158l-.614-.308v.158ZM11.522 19.256l1.228.616v-.158l-1.228-.616v.158ZM10.632 18.81l.644.323v-.158l-.644-.323v.157ZM10.955 18.582l1.397.7v-.158l-1.397-.7v.158ZM10.33 18.269l.418.209v-.158l-.418-.209v.158ZM11.806 18.588l.945.473v-.158l-.945-.473v.158Z",
    fill: "#FF0082"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.12 18.245.497.248v-.157l-.496-.25v.159Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.294 17.83.614.308v-.158l-.614-.308v.158Z",
    fill: "#FF0082"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.71 20.566.957.48v-.158l-.957-.48v.158Z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.294 20.794 1.228.616v-.158l-1.228-.616v.158ZM11.768 21.533l.645.323v-.158l-.645-.323v.158ZM10.693 21.384l1.396.7v-.159l-1.396-.7v.159ZM12.298 22.188l.416.209v-.158l-.416-.209v.158ZM10.693 23.636l1.396.7v-.159l-1.396-.699v.158ZM12.298 24.44l.416.21v-.159l-.416-.209v.159ZM10.294 23.857l.944.473v-.158l-.944-.473v.158Z",
    fill: "#FF0082"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.427 24.425.496.248v-.157l-.496-.25v.159Z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.136 24.78.614.308v-.158l-.614-.308v.158Z",
    fill: "#FF0082"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.71 25.893.957.48v-.16l-.957-.479v.159Z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.693 26.71 1.396.699v-.158l-1.396-.7v.158ZM12.298 27.513l.416.209v-.158l-.416-.21v.16ZM10.294 26.93l.944.473v-.158l-.944-.473v.158Z",
    fill: "#FF0082"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.426 27.498.497.248v-.158l-.497-.249v.159Z",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.136 27.853.614.308v-.158l-.614-.308v.158Z",
    fill: "#FF0082"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m24.981 28.175.724.369v-.122l-.724-.368v.121ZM25.98 28.683l.977.497v-.122l-.977-.497v.122ZM24.541 28.285l.93.472v-.121l-.93-.473v.122ZM25.656 28.853l.488.247v-.12l-.488-.248v.12ZM26.355 29.206l.604.308v-.122l-.604-.306v.12ZM24.842 28.738l1.057.537v-.12l-1.057-.538v.121ZM26.057 29.355l.316.16v-.121l-.316-.16v.12ZM24.541 28.907l.715.363v-.121l-.715-.363v.12ZM25.399 29.343l.375.19v-.12l-.375-.191v.121ZM25.936 29.617l.464.236v-.121l-.464-.237v.122ZM25.307 29.596l.838.426V29.9l-.838-.426v.121ZM24.373 29.72l.981.499v-.122l-.981-.498v.12ZM24.541 29.505l.93.473v-.121l-.93-.473v.121ZM25.656 30.073l.488.248V30.2l-.488-.248v.12ZM26.355 30.427l.604.307v-.121l-.604-.308v.122ZM25.54 30.313l.86.438v-.122l-.86-.437v.121ZM25.005 30.375l1.352.686v-.121l-1.352-.687v.122ZM25.005 30.65l.709.36v-.121l-.709-.36v.121ZM24.657 30.773l1.243.631v-.122l-1.242-.631v.122ZM26.057 31.484l.316.16v-.122l-.316-.16v.122Z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.446 32.836c-.495.08-.315 1.62-.866 1.312-.627-.352-1.28-2.34-1.75-2.636-.644-.403-1.047 2.027-1.047 2.027l4.374 2.246c.153-1.138-.223-3.028-.71-2.95Z",
    fill: "#FF0082"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.595 34.248c-.314.05-.376.784-.592.074-.163-.535-.436-2.55-.876-2.476-.697.117-.14 1.679-.734 1.774-.417.068-.565-1.35-1.042-1.27-.375.062-.569 1.189-.569 1.189l4.348 2.22c.1-.885-.093-1.58-.535-1.51Z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.87 34.744c-.22-.123-.267.494-.546.348-.314-.164-.438-1.612-.733-1.787-.34-.202-.484 1.138-1.004.866-.546-.285-.509-.845-1.17-1.209-.604-.332-.635.577-.635.577l4.353 2.22s.096-.814-.264-1.015Z",
    fill: "#3047B0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m20.247 30.414 1.665.84v-.235l-1.665-.84v.235ZM14.65 27.59l2.192 1.106v-.234l-2.193-1.107v.235ZM17.22 28.887l2.788 1.406v-.235l-2.787-1.405v.234ZM14.65 28.04l1.217.613v-.234l-1.218-.614v.235ZM16.165 28.804l2.479 1.25v-.235l-2.479-1.25v.235ZM18.923 30.195l2.17 1.095v-.235l-2.17-1.094v.234ZM21.352 31.42l.56.283v-.235l-.56-.282v.234ZM14.65 28.488l7.262 3.664v-.235l-7.263-3.663v.234ZM14.65 28.938l1.217.614v-.235l-1.218-.614v.235ZM16.165 29.703l2.479 1.25v-.235l-2.479-1.25v.235ZM18.922 31.093l2.17 1.095v-.235l-2.17-1.094v.234ZM21.352 32.32l.56.282v-.235l-.56-.282v.234ZM17.22 30.684l2.788 1.406v-.235L17.22 30.45v.234ZM14.65 29.387l2.192 1.106v-.235l-2.193-1.106v.235ZM20.247 32.21l1.665.84v-.234l-1.665-.84v.235ZM14.563 16.22v.394-.001.017l.002.405-.002-.001v.016l.002.001.002.406-.004-.003v.016l.004.002.002.405-.006-.002v.016l.006.003.001.405-.007-.003v.016l.007.003.002.406-.009-.005v.017l.009.004v.405l-.009-.005v.016l.01.005.002.406-.012-.006v.016l.012.006.001.405-.013-.006v.016l.013.006.002.405-.015-.007v.016l.015.008v.405l-.015-.008v.015l12.931 6.501v-.857l-.002-.406.002.001v-.016l-.002-.001-.002-.405.004.002v-.016l-.003-.002-.002-.406.005.003v-.016l-.005-.003-.002-.405.007.003v-.016l-.007-.004-.001-.405.008.005v-.016l-.008-.004-.002-.406.01.005v-.016l-.01-.005-.001-.405.01.005v-.016l-.01-.005-.002-.405.013.006v-.016l-.013-.007-.001-.405.014.008v-.016l-12.931-6.502v.029Zm10.354 9.805-.002-.405 2.554 1.283.002.406-2.554-1.284Zm2.552.862-2.553-1.284-.002-.405 2.554 1.284.001.405Zm-.001-.421-2.554-1.284-.001-.405 2.553 1.283.002.406Zm-.001-.422-2.554-1.284-.001-.405 2.554 1.284v.405Zm-.002-.421-2.553-1.284-.002-.405 2.553 1.283.002.406Zm-.002-.421-2.553-1.284-.002-.405 2.554 1.284.002.405Zm0-.422-2.554-1.283-.001-.406 2.553 1.284.001.405Zm-.003-.421-2.553-1.284-.002-.405 2.554 1.284.001.405Zm0-.422-2.554-1.283-.001-.406 2.553 1.284.001.405Zm-.003-.42-2.553-1.284-.002-.405 2.554 1.283.002.405Zm-.002-.828v.405l-2.553-1.283-.001-.406 2.554 1.284Zm-2.563 3.323-2.553-1.284-.002-.405 2.553 1.284.002.405Zm-.002-.422-2.553-1.283-.001-.406 2.553 1.284.002.405Zm0-.42-2.554-1.284-.002-.405 2.554 1.283.001.406Zm-.002-.422-2.554-1.284-.001-.405 2.553 1.284.002.405Zm-.001-.421-2.554-1.284v-.405l2.553 1.283v.406Zm-.002-.422-2.553-1.283-.002-.406 2.554 1.284.001.405Zm-.002-.421L22.33 22.2l-.002-.405 2.554 1.283.002.406Zm-.001-.422-2.554-1.283-.001-.406 2.553 1.284.002.405Zm-.001-.42-2.554-1.284v-.406l2.553 1.284v.405Zm-.002-.422-2.553-1.284-.002-.405 2.554 1.284.001.405Zm-.003-.827.002.406-2.554-1.284-.002-.405 2.555 1.283Zm-2.562 3.323-2.554-1.284-.001-.405 2.554 1.284v.405Zm-2.555-1.705-.001-.405 2.553 1.283.002.405-2.554-1.283Zm2.552.862-2.554-1.284-.002-.405 2.554 1.284.002.405Zm-.002-.421-2.553-1.284-.001-.405 2.553 1.284.002.405Zm-.001-.422-2.554-1.283-.001-.406 2.554 1.284v.405Zm-.001-.42-2.554-1.284v-.406l2.553 1.284v.405Zm-.002-.422-2.554-1.284-.002-.405 2.554 1.284.002.405Zm-.001-.422-2.554-1.283-.002-.406 2.554 1.284.002.405Zm-.002-.42-2.553-1.285-.002-.405L22.3 20.94l.002.405Zm-.001-.422-2.554-1.284v-.405L22.3 20.52v.405Zm-.003-.827.001.406-2.554-1.284v-.405l2.553 1.283Zm-2.563 3.323-2.553-1.284-.002-.405 2.554 1.283.001.406Zm-.001-.421-2.554-1.284-.001-.405 2.553 1.284.002.405Zm-.002-.422-2.553-1.284-.002-.405 2.554 1.284.001.405Zm0-.421-2.554-1.284-.002-.405 2.554 1.284.001.405Zm-.002-.422-2.554-1.283-.001-.406 2.553 1.284.002.405Zm-.002-.42-2.554-1.285-.001-.404 2.553 1.283.002.405Zm-.001-.422-2.554-1.284-.001-.405 2.553 1.283.002.406Zm-2.555-1.705-.002-.405 2.554 1.283v.406l-2.552-1.284Zm2.552.862-2.554-1.284-.002-.405 2.554 1.284.002.405Zm-.002-.422-2.553-1.283-.002-.406 2.554 1.284.002.405Zm-.003-.826.001.405-2.553-1.284-.001-.405 2.553 1.284Zm-2.562 3.323-2.554-1.284v-.405l2.553 1.283.001.406Zm-.002-.421-2.553-1.284-.002-.405 2.554 1.283.002.405Zm-.001-.422L14.6 19.997l-.002-.405 2.553 1.283.002.406Zm-.002-.421L14.6 19.576l-.001-.406 2.553 1.284.001.405Zm0-.422-2.554-1.283-.002-.405 2.554 1.283.001.405Zm-.002-.421-2.554-1.284-.002-.405 2.554 1.284.002.405Zm-.002-.421-2.553-1.284-.002-.406 2.553 1.284.002.406Zm-.001-.422-2.554-1.284-.001-.405 2.553 1.284.002.405Zm-.002-.421-2.553-1.284-.002-.405 2.554 1.284.001.405Zm-.001-.421-2.554-1.285v-.405l2.553 1.284v.406Zm-.003-.827.002.405-2.554-1.284-.002-.405 2.554 1.284Z",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M26.132 24.817c0-.078-.094-.188-.209-.246-.115-.058-.207-.041-.207.037 0 .03.013.063.036.098l-1.964.272a.47.47 0 0 0-.165-.138.317.317 0 0 0-.098-.032l-1.106-1.548a.064.064 0 0 0 .03-.057c0-.079-.094-.189-.21-.247-.114-.058-.207-.04-.207.037 0 .04.023.085.06.13l-.511.335a.496.496 0 0 0-.07-.044.336.336 0 0 0-.097-.032l-1.651-2.222a.064.064 0 0 0 .037-.062c0-.078-.093-.188-.208-.246-.115-.058-.208-.041-.208.037 0 .03.014.063.036.097l-1.144.525a.364.364 0 0 0-.12-.059l-.49-1.168c.055.001.091-.023.091-.072 0-.078-.094-.188-.209-.246-.114-.058-.207-.041-.207.037a.16.16 0 0 0 .02.07l-1.031-.106a.463.463 0 0 0-.168-.143c-.082-.041-.152-.044-.186-.014l-.91-.631v.046l.89.618-.002.018c0 .079.093.189.208.247.115.058.208.04.208-.037a.14.14 0 0 0-.011-.049l1.038.107a.485.485 0 0 0 .21.143l.49 1.171c-.053 0-.087.024-.087.071.001.078.094.189.21.246.114.058.207.041.207-.037 0-.048-.037-.11-.091-.162l1.13-.518a.485.485 0 0 0 .126.093c.047.023.09.034.125.034l1.643 2.212c-.036.008-.058.03-.058.069 0 .078.094.188.21.246.114.058.207.041.207-.037 0-.045-.033-.1-.08-.151l.507-.334c.028.025.06.047.095.064a.264.264 0 0 0 .135.034l1.097 1.535c-.035.008-.057.031-.057.069 0 .078.094.188.209.246.115.057.207.041.207-.037a.144.144 0 0 0-.012-.052l1.978-.274c.035.036.079.07.126.093a.253.253 0 0 0 .146.033l.964.967.016-.04-.941-.944a.063.063 0 0 0 .023-.052Z",
    fill: "#FF0082"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.452 24.334c.021-.066-.054-.178-.166-.249-.113-.07-.222-.075-.243-.009a.098.098 0 0 0 0 .049l-.814-.128a.435.435 0 0 0-.142-.14.305.305 0 0 0-.17-.055l-1.053-1.149.005-.01c.021-.066-.053-.177-.166-.249-.113-.07-.222-.075-.243-.009v.002l-1.836-.78a.404.404 0 0 0-.159-.175c-.07-.044-.137-.063-.184-.055l-1.598-1.303.001-.001c.021-.066-.053-.178-.166-.25-.113-.07-.222-.074-.243-.008-.002.007-.002.013-.002.02l-2.113-.76a.407.407 0 0 0-.156-.167c-.079-.05-.154-.066-.2-.05l-.742-.654.001.052.708.625a.074.074 0 0 0-.01.017c-.02.067.055.178.168.25.113.07.221.074.242.008.003-.01.004-.02.003-.032l2.108.76c.023.06.081.129.16.178.09.057.176.07.22.04l1.58 1.292a.062.062 0 0 0-.018.027c-.022.067.053.178.166.249.113.071.221.075.243.009a.086.086 0 0 0 .002-.024l1.826.776c.013.064.078.145.167.201.083.053.163.068.208.047l1.038 1.133a.061.061 0 0 0-.029.034c-.02.067.054.178.167.25.113.07.222.075.243.008a.096.096 0 0 0-.001-.055l.81.127c.03.052.081.106.146.147.081.05.159.067.205.048l1.598 1.532.016-.039-1.584-1.518.007-.012Z",
    fill: "url(#gamification-header-icon_svg__e)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m27.002 27.94-.767-.386.004.26.751.377c.01.005.023-.001.023-.012l.005-.21a.046.046 0 0 0-.006-.02.035.035 0 0 0-.01-.01ZM24.738 26.834l-.766-.385.004.26.75.376c.01.005.023 0 .024-.012l.004-.209a.043.043 0 0 0-.006-.021l-.01-.01ZM22.474 25.727l-.766-.384.004.26.75.376c.01.005.023-.002.024-.012l.004-.21a.044.044 0 0 0-.007-.02.04.04 0 0 0-.009-.01ZM20.209 24.622l-.767-.385.004.26.751.377c.01.005.023-.002.023-.012l.005-.21a.035.035 0 0 0-.007-.02.028.028 0 0 0-.01-.01ZM17.946 23.516l-.767-.385.005.26.75.376c.01.005.023-.002.024-.012l.005-.21a.042.042 0 0 0-.008-.02.047.047 0 0 0-.01-.01ZM15.68 22.41l-.766-.384.004.26.75.376c.01.005.023-.001.024-.011l.004-.21a.037.037 0 0 0-.007-.02c-.003-.006-.007-.01-.008-.01Z",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m16.842 25.487.237.115c.013-.254.146-.41.334-.421l-.104-.307c-.267.018-.455.245-.467.613Z",
    fill: "#FF0082"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M17.646 24.95a.665.665 0 0 0-.337-.076l.104.307a.472.472 0 0 1 .234.053c.317.154.577.59.58.972.002.381-.254.566-.57.412-.317-.154-.576-.59-.58-.972l.002-.044-.237-.115v.045c.003.538.37 1.153.817 1.37.447.218.807-.043.803-.581a1.665 1.665 0 0 0-.281-.869 1.41 1.41 0 0 0-.535-.503Z",
    fill: "url(#gamification-header-icon_svg__f)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m19.41 26.798.236.116c.013-.255.146-.411.334-.421l-.104-.307c-.267.017-.455.245-.467.612Z",
    fill: "#FF0082"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M20.212 26.26a.678.678 0 0 0-.336-.075l.105.307a.474.474 0 0 1 .234.054c.316.154.576.59.578.971.003.382-.253.567-.57.412-.316-.154-.576-.59-.578-.971 0-.016 0-.03.002-.044l-.237-.116-.001.045c.004.538.37 1.153.817 1.371.447.218.807-.043.804-.582a1.664 1.664 0 0 0-.282-.869 1.402 1.402 0 0 0-.536-.502Z",
    fill: "url(#gamification-header-icon_svg__g)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m21.974 28.108.237.115c.013-.254.146-.41.334-.421l-.104-.307c-.267.018-.455.245-.467.613Z",
    fill: "#FF0082"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M22.777 27.57a.668.668 0 0 0-.336-.075l.105.307a.473.473 0 0 1 .234.053c.316.154.576.59.578.972.003.381-.253.567-.57.412-.316-.154-.576-.59-.578-.971l.002-.045-.238-.115v.045c.004.538.37 1.154.816 1.371.447.218.808-.043.805-.582a1.667 1.667 0 0 0-.282-.868 1.406 1.406 0 0 0-.535-.503Z",
    fill: "url(#gamification-header-icon_svg__h)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "m22.261 29.865 1.044.532v-.37l-1.044-.533v.37ZM19.604 28.522l1.044.532v-.37l-1.044-.533v.371ZM16.948 27.178l1.043.532v-.37l-1.043-.533v.371ZM14.29 25.835l1.044.533v-.37l-1.043-.533v.37Z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "m14.278 24.176.237.116c.013-.255.146-.411.334-.421l-.104-.307c-.268.017-.455.245-.467.612Z",
    fill: "#FF0082"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M15.081 23.64a.666.666 0 0 0-.337-.076l.105.307a.473.473 0 0 1 .234.053c.316.154.576.59.579.971.002.382-.253.567-.57.413-.317-.155-.576-.59-.579-.972l.002-.044-.238-.115v.044c.004.538.37 1.154.817 1.371.447.218.808-.043.804-.582a1.674 1.674 0 0 0-.281-.87 1.409 1.409 0 0 0-.536-.5Z",
    fill: "url(#gamification-header-icon_svg__i)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8.052 22.099c.496-.576 1.348-1.127 1.896-1.822.507-.64.838-1.33 1.192-1.995.35-.053 1.092-.216 1.215-.553.13-.357-.309-.686-.196-1.033.08-.244.477-.253.388-.58-1.269.35-2.07 1.288-2.83 2.23-.226.278-.472.573-.743.844-.532.533-.916 1.166-1.079 1.854-.105.453-.115.884.157 1.055Z",
    fill: "url(#gamification-header-icon_svg__j)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81 17.74c.096-.097.327-.277.446-.285.047-.004.053.02.067.168.03.319.701.902.702 1.24.003 1.143-1.965 3.223-3.31 3.685-1.193.41-4.05-.95-4.595-1.276-.546-.326-1.1-1.432.112-1.822 1.21-.391 3.557 1.107 3.908 1.09.755-.035 1.997-2.124 2.67-2.8Z",
    fill: "url(#gamification-header-icon_svg__k)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M8.226 46.174c0 .696-.259 1.434-.091 2.064.93.384 1.112-.014 1.182-.95.134-.215.296-.976.321-1.275",
    fill: "url(#gamification-header-icon_svg__l)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1.713 44.679c0 .695-.08 1.43.047 2.05.792.384 1.16-.133 1.284-1.122.114-.215.105-.706.127-1.006",
    fill: "url(#gamification-header-icon_svg__m)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M2.657 30.474c-1.37 1.222-.39 3.056-.34 4.017.055 1.067-.067 1.042-.066 2.137.003 2.432-.493 4.616-.62 7.03-.031.574.008 1.478.047 2.044.36.086 1.014.37 1.33.198.099-.053 1.878-5.252 2.27-5.896.578-.952.637-2.498 1.039-3.757.367-1.153.308-1.826.677-2.981.2-.627-.241-.997-.082-1.648.07-.287.188-.66.152-.955-.04-.32-.376-.514-.138-.823",
    fill: "url(#gamification-header-icon_svg__n)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M7.699 30.476c2.44 1.438 3.678 7.547 3.32 10.663-.044.379-.833 5.288-1.702 6.15-.15.147-1.309.097-1.296-.184.29-6.863.435-7.644-4.477-14.66",
    fill: "url(#gamification-header-icon_svg__o)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "m6.391 17.534-.181 1.511c-.014.118-.12.212-.256.231-.62.09-1.09-.095-1.372-.261a.442.442 0 0 1-.217-.506l.326-1.114 1.7.14Z",
    fill: "url(#gamification-header-icon_svg__p)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M7.291 15.075s.34 1.902.118 2.405c-.223.503-1.62.733-1.977.584-.358-.15-1.413-1.186-1.47-1.643-.325-2.649 1.595-2.701 3.33-1.346Z",
    fill: "url(#gamification-header-icon_svg__q)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M2.674 27.315c-.138-1.302-1.644-6.588-.144-7.823.574-.472.802-.687 1.52-.49.04-.258.037-.558.315-.492 1.183.277.947.084 1.912.04.298-.015-.04.857.014 1.015.078.227.185.414.313.583.65.445 1.47 1.185 1.853 2.26.069.195.088.52.085.925.02.312.002.66-.035 1.036-.044 1.004-.1 2.185.056 3.144.272 1.687.854 3.08 1.217 4.025.158.25.31.953.312 1.066.002.1-.559.497-1.546.814-.988.317-4.642-.024-6.143-.975 0 0-1.007-.32-.05-3.409.188-.605.378-1.177.321-1.719Z",
    fill: "url(#gamification-header-icon_svg__r)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M5.773 29.579 9.2 28.578l.986 2.661-4.29 1.06-.37-.177.247-2.543Z",
    fill: "#2E2E2E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M8.953 28.86c-.108-.186-.467-1.335-.497-1.524l.3.034c.22.294.446 1.192.485 1.384l-.288.106ZM5.771 29.682c-.008-.833-.377-1.626-.698-2.4a58.397 58.397 0 0 0-.505-1.188c-.168-.381-.357-.755-.465-1.153-.105-.385-.164-.777-.259-1.164-.054-.22-.12-.437-.167-.659-.105-.496-.168-1.01-.113-1.514.052-.482.215-.998.683-1.306.539-.354 1.218-.343 1.796-.064.626.304 1.1.84 1.382 1.398.185.365.281.759.385 1.146.136.508.263 1.018.4 1.527.116.429.351 1.121.524 1.537.029.07.047.11.078.164.08.142-.168.268-.25.125-.185-.326-.402-.953-.503-1.303-.141-.492-.267-.988-.395-1.483-.109-.418-.211-.84-.35-1.251a2.964 2.964 0 0 0-.919-1.323c-.428-.355-1.043-.632-1.643-.439-.554.18-.791.64-.876 1.109-.088.482-.04.987.05 1.466.034.185.077.37.128.552.1.353.165.71.243 1.067.171.79.564 1.522.88 2.274.318.752.686 1.515.827 2.31.034.189.054.38.056.571.001.16-.287.16-.289 0ZM.522 17.06c.005-.232-.105-.363.052-.589.168-.244.42-.277.608-.416.244-.18.122-.443.276-.653.166-.266.64-.26.718-.588.056-.228.079-.503.281-.7.22-.213.405-.243.62-.35.374-.186.411-.428.848-.586.497-.18.695.028 1.15.004.436-.023 1.178-.035 1.376.07.156.082.399.122.593.19.526.184.432.4.434.757.001.3.399.425.377.706-.025.309-.264.286-.5.41-.47.249-.424.794-.893 1.062-.195.112-.635-.066-.865.15-.108.102-.104.286-.124.447a.642.642 0 0 0 .04.28c.05.096.25.288.142.518-.135.29-.425.236-.197.646.11.196.407.294.477.493.07.198.03.405-.2.52-.216.107-.344.022-.761.045-.619.034-.643.238-1.09.213-.208-.012-.479-.171-.622-.208-.38-.097-.537.057-.855-.025-.365-.095-.436-.342-.77-.39-.468-.067-.685.158-1.088-.238-.172-.17-.117-.318-.204-.513-.112-.25-.143-.213-.281-.456-.28-.492.45-.344.458-.798ZM1.438 47.398c.043-.282.132-.59.265-.902.004-.009.016-.013.026-.008.277.12.952.17 1.105-.093l.037.071c.058.182.075.312.108.417a6.763 6.763 0 0 0 1.362.026c.184-.021.38.062.429.216.035.111.053.28-.215.422l-2.096.798c-.24.107-.522.123-.777.043-.142-.044-.242-.154-.257-.283a5.033 5.033 0 0 1 .013-.707ZM7.826 48.968c.037-.283.12-.59.246-.906.004-.009.016-.013.026-.008.28.116.97.198 1.117-.066l.039.07c.077.176.067.268.102.372a6.765 6.765 0 0 0 1.362.006.407.407 0 0 1 .42.246c.046.121.099.346-.166.492l-2.106.726c-.238.11-.52.131-.776.055-.144-.042-.245-.15-.263-.279a5.09 5.09 0 0 1-.001-.708Z",
    fill: "#2E2E2E"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M11.264 26.538c1.062-.68 2.468.053 2.476 1.183 0 .108-.117.199-.235.165a.186.186 0 0 1-.062-.031c-.162-.127-.389-.553-.761-.618-.44-.077-.688.052-1.218-.174l-.2-.525Z",
    fill: "url(#gamification-header-icon_svg__s)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M10.944 26.123s.71-.06.888.521c.18.582 0 .774 0 .774s-3.835.476-4.968-.298c-1.005-.687-2.738-4.883-2.676-5.45.062-.568.91-1.526 1.905-.816.995.71 1.408 3.548 2.364 4.434.512.476 2.487.835 2.487.835Z",
    fill: "url(#gamification-header-icon_svg__t)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gamification-header-icon_svg__d",
    x1: 6.31,
    y1: 22.32,
    x2: 30.599,
    y2: 22.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3047B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gamification-header-icon_svg__e",
    x1: 15.062,
    y1: 22.055,
    x2: 27.029,
    y2: 22.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3047B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gamification-header-icon_svg__f",
    x1: 16.842,
    y1: 25.926,
    x2: 18.462,
    y2: 25.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3047B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gamification-header-icon_svg__g",
    x1: 19.409,
    y1: 27.238,
    x2: 21.03,
    y2: 27.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3047B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gamification-header-icon_svg__h",
    x1: 21.974,
    y1: 28.547,
    x2: 23.595,
    y2: 28.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3047B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gamification-header-icon_svg__i",
    x1: 14.277,
    y1: 24.616,
    x2: 15.898,
    y2: 24.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3047B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gamification-header-icon_svg__j",
    x1: 7.657,
    y1: 19.268,
    x2: 12.776,
    y2: 18.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gamification-header-icon_svg__k",
    x1: 11.025,
    y1: 20.04,
    x2: 2.507,
    y2: 20.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gamification-header-icon_svg__l",
    x1: 9.638,
    y1: 47.198,
    x2: 8.078,
    y2: 47.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gamification-header-icon_svg__m",
    x1: 3.171,
    y1: 45.729,
    x2: 1.688,
    y2: 45.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gamification-header-icon_svg__n",
    x1: 1.619,
    y1: 37.897,
    x2: 7.07,
    y2: 37.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3047B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gamification-header-icon_svg__o",
    x1: 3.544,
    y1: 38.922,
    x2: 11.08,
    y2: 38.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3047B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0087FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gamification-header-icon_svg__p",
    x1: 5.37,
    y1: 20.607,
    x2: 5.37,
    y2: 16.167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gamification-header-icon_svg__q",
    x1: 4.015,
    y1: 21.262,
    x2: 6.533,
    y2: 11.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gamification-header-icon_svg__r",
    x1: 11.051,
    y1: 26.016,
    x2: -0.896,
    y2: 26.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gamification-header-icon_svg__s",
    x1: 11.264,
    y1: 27.085,
    x2: 13.74,
    y2: 27.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.216,
    stopColor: "#AB4904"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    stopColor: "#A64704"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#994105"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691,
    stopColor: "#823707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867,
    stopColor: "#632A09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#612909"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gamification-header-icon_svg__t",
    x1: 4.186,
    y1: 24.082,
    x2: 11.912,
    y2: 24.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0082"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gamification-header-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(13.946 24.115)",
    d: "M0 0h1.775v1.569H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gamification-header-icon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(11.473 24.115)",
    d: "M0 0h1.838v1.569H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "gamification-header-icon_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8.114 24.331)",
    d: "M0 0h1.395v1.19H0z"
  })))));
};
export { SvgGamificationHeaderIcon as ReactComponent };
export default __webpack_public_path__ + "2ce0708f2d0611f3716026fcda030ebd.svg";